import React from "react";
import { IconItem } from "./nounproject-icon-item";

import IconHero from "./nounproject-icon-hero";
import IconDetail from "../containers/nounproject-icon-detail";

export class IconRow extends React.Component {
    onSelectIcon(icon) {
        return this.props.onSelectIcon(icon);
    }

    render() {
        let classString, hero, icons, iconsPerRow, ref, row, rowClass, selected;
        icons = this.props.icons;
        iconsPerRow = this.props.iconsPerRow;
        row = [];
        icons.forEach(icon => {
            if (this.props.selectedIcon) {
                selected = icon.id === this.props.selectedIcon;
            }
            if (this.props.heroIconId) {
                selected = icon.id == this.props.heroIconId;
            }
            row.push(
                <IconItem
                    key={icon.id}
                    iconKey={icon.id}
                    icon={icon}
                    iconsPerRow={iconsPerRow}
                    onSelectIcon={this.onSelectIcon.bind(this)}
                    selected={selected}
                    showToolTip={false}
                />
            );
        });
        if (this.props.showHero) {
            let iconId;
            if (this.props.heroIconId) {
                iconId = this.props.heroIconId;
            } else if (this.props.heroIcon) {
                iconId = this.props.heroIcon.id;
            }
            hero = (
                <IconDetail
                    scrollToElement
                    showInModal
                    iconId={iconId}
                    onCloseAction={this.props.onHeroClose}
                />
            );
        }
        rowClass = "_" + iconsPerRow;
        classString = "Grid-cell-row container " + rowClass;
        if (row.length < iconsPerRow) {
            while (row.length < iconsPerRow) {
                row.push(
                    <div
                        key={"spacer." + row.length}
                        className="Grid-cell loaded spacer"
                    />
                );
            }
        }
        return (
            <section className="row-container">
                {hero}
                <div className={classString}>{row}</div>
            </section>
        );
    }
}
